import { MutationTree } from "vuex";
import { MainState, MainStateMutations, StateState } from "./interface";
import { MainStateMutationsTypes } from "./types";

export const mutations: MutationTree<StateState> & MainStateMutations = {
  [MainStateMutationsTypes.SET_MAIN_STATE](state: StateState, payload: Array<MainState>): void {
    state.StateById = {};
    state.StateAllId = [];

    payload.forEach((role) => {
      state.StateById[role._id] = role;
      state.StateAllId.push(role._id);
    });
  }
};
